import { showToast } from '@/helpers/UseToasts'
import axios from 'axios'

export class PdfCreate {
  constructor (apiUrl) {
    this.apiUrl = apiUrl
    this.toast = showToast
  }

  async fetchPdf (requestData = null) {
    try {
      const response = await axios({
        url: this.apiUrl,
        method: 'POST',
        data: requestData,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/pdf',
          Authorization: localStorage.getItem('__access'),
          __company_id: localStorage.getItem('__company')
        }
      })

      const url = window.URL.createObjectURL(response.data)
      this.displayPdf(url)
    } catch (error) {
      // console.log(error)
      if (error.response.data.error && error.response.data.status === 404) {
        return this.toast(
          'Aviso',
          error.response.data.message,
          'error'
        )
      }

      return this.toast(
        'Aviso',
        'Relatório não foi emitido',
        'error'
      )
    }
  }

  async fetchExcelByItemId (id, name) {
    try {
      const response = await axios({
        url: this.apiUrl,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          Authorization: 'Bearer ' + localStorage.getItem('__access'),
          __company_id: localStorage.getItem('__company')
        }
      })

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })

      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${name ?? 'relatório_item'} - ${id}.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      window.URL.revokeObjectURL(url)
    } catch (error) {
      if (error.response.data.error && error.response.data.status === 404) {
        return this.toast(
          'Aviso',
          error.response.data.message,
          'error'
        )
      }

      return this.toast(
        'Aviso',
        'Não foi possivel emitir o arquivo',
        'error'
      )
    }
  }

  // TODO: deixar apenas função superior - alterar parametros
  async fetchExcelBySector (name) {
    try {
      const response = await axios({
        url: this.apiUrl,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          Authorization: 'Bearer ' + localStorage.getItem('__access'),
          __company_id: localStorage.getItem('__company')
        }
      })

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })

      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `relatorio - ${name}.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      window.URL.revokeObjectURL(url)
    } catch (error) {
      if (error.response.data.error && error.response.data.status === 404) {
        return this.toast(
          'Aviso',
          error.response.data.message,
          'error'
        )
      }

      return this.toast(
        'Aviso',
        'Não foi possivel emitir o arquivo',
        'error'
      )
    }
  }

  displayPdf (pdfUrl) {
    window.open(pdfUrl, '_blank')
  }
}
